<div class="p-4">
  <div class="flex items-center justify-between flex-wrap gap-3 mb-4">
    <h1 class="text-2xl font-semibold">Events</h1>
    <button (click)="addEvent($event)" class="btn-primary flex gap-2" [disabled]="startingEvent">
      @if (this.startingEvent){
          <span class="material-symbols-outlined">sync</span> <span>Starting Reporting...</span>
      } @else {
          <span class="material-symbols-outlined">add</span> <span>Report New Event</span>
      }
    </button>
  </div>

  <p-confirmpopup key="templateSelect" styleClass="template-popup">
    <ng-template pTemplate="headless" let-confirmation>
      <div class="template-popup-wrapper flex flex-col gap-3 p-4">
        <div>
          <p class="font-semibold text-sm">Select a template</p>
          <p class="text-sm text-grey-700">Choose which template to use for this event.</p>
        </div>
        <p-select
          class="w-full"
          [options]="availableTemplates"
          optionLabel="TemplateName"
          optionValue="EventWorkflowID"
          placeholder="Select a template"
          [(ngModel)]="selectedTemplateId">
        </p-select>
        <div class="flex gap-2 justify-end">
          <button type="button" class="btn-inverse btn-compact btn-xs" (click)="cancelTemplateSelection()">Cancel</button>
          <button type="button" class="btn-primary btn-compact btn-xs" (click)="confirmTemplateSelection()" [disabled]="!selectedTemplateId">Use Template</button>
        </div>
      </div>
    </ng-template>
  </p-confirmpopup>

  <div class="card filter-card">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col md:flex-row md:items-end gap-3">
        <div class="flex-1">
          <label class="label mb-1">Status</label>
          <p-multiselect
            class="w-full"
            [options]="eventStatuses"
            optionLabel="EventStatusDescription"
            optionValue="EventStatusID"
            display="chip"
            [showToggleAll]="false"
            placeholder="Select status"
            [(ngModel)]="selectedStatusIds">
          </p-multiselect>
        </div>
        <div>
          <label class="label mb-1">Reported From</label>
          <p-datepicker class="date-input w-full" [showIcon]="false" [(ngModel)]="reportedFrom" dateFormat="dd M yy"></p-datepicker>
        </div>
        <div>
          <label class="label mb-1">Reported To</label>
          <p-datepicker class="date-input w-full" [showIcon]="false" [(ngModel)]="reportedTo" dateFormat="dd M yy"></p-datepicker>
        </div>
      </div>
      <div class="flex flex-col md:flex-row md:items-end gap-3">
        <div class="flex-1">
          <label class="label mb-1">Location</label>
          <p-multiselect
            class="w-full"
            [options]="locationOptions"
            optionLabel="name"
            optionValue="id"
            display="chip"
            [showToggleAll]="false"
            placeholder="All locations"
            [(ngModel)]="selectedLocationIds">
          </p-multiselect>
        </div>
        <div class="flex gap-2">
          <button type="button" class="btn-inverse btn-compact" [disabled]="loadingEvents" (click)="clearFilters()">Clear</button>
          <button type="button" class="btn-primary btn-compact" [disabled]="loadingEvents" (click)="applyFilters()">Apply</button>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4">
    @if (loadingEvents) {
      <p class="text-sm text-grey-700">Loading events...</p>
    }
    @if (filteredEvents.length === 0) {
      <p class="text-sm text-grey-700">No events match the selected filters.</p>
    }
    @for (i of filteredEvents; track i.EventID){
        <app-event-overview-panel [event]="i" class="m-4"></app-event-overview-panel> 
    }
  </div>
</div>  
